import React from "react"
import { ImgS } from "ui-seeker/core"

import { IMAGE } from 'app/@common/constants'


const FALLBACK_LOGO = `${IMAGE.ASSETS}/web.png`
// Apply the fallback only once: if web.png also fails, onError would re-fire forever.
const onLogoError = i => {
    if (i.target.src !== FALLBACK_LOGO) i.target.src = FALLBACK_LOGO
}

const TmpLogo=({ siteName }) => <abbr style={{
    display: 'inline-block', verticalAlign: 'middle', width: '20px', textAlign: 'center', lineHeight: '0'
}}>
    <ImgS
        src={`${IMAGE.ASSETS}/${siteName?.split('.')[0]}-mini.png`} alt={`${siteName} logo`} onError={onLogoError}
        style={{ display: "inline-block", height: "1em", verticalAlign: "middle", maxWidth: '100%'}}
    />
</abbr>

const TmpSiteName=({ siteName='' }) => <abbr style={{ display: 'inline-block', verticalAlign: 'middle' }}>{` ${siteName}`}</abbr>

export const formatSiteWithLogo=({ siteName } = {}) => {
    return <>
        <TmpLogo siteName={siteName} /> <TmpSiteName siteName={siteName} />
    </>
}